import { ThemePackage } from '../types/theme';

export class ThemeCompact implements ThemePackage {
  defaultRowSize = 32;
}
